import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchNotifications, NotificationsQueryParams } from "../../services/NotificationsService";

export const fetchNotificationsAsync = createAsyncThunk(
  "notifications/fetchList",
  async (params: NotificationsQueryParams, { rejectWithValue }) => {
    try {
      const response = await fetchNotifications(params);
      return response;
    } catch (error: unknown) {
      // Error envelopes are shaped { "msg": "..." }; surface that message to the UI.
      const err = error as { response?: { data?: { msg?: string } }; message?: string };
      return rejectWithValue(
        err.response?.data?.msg || err.message || "An unexpected error occurred"
      );
    }
  }
);
